import { createRouter, createWebHistory } from 'vue-router';

import { getSanitisedHazardType, HazardTypeToRouteTitleMap } from '@/features';
import { i18n } from '@/locales';
import { captureException, captureMessage } from '@sentry/vue';
import { useTitle } from '@vueuse/core';
import { routes } from '../router/routes';
import { RouteNames } from './types';

const { t } = i18n.global;

export const router = createRouter({
  history: createWebHistory('/'),
  routes,
});

router.onError((error, to) => {
  if (error.message.includes('Failed to fetch dynamically imported module') || error.message.includes('Importing a module script failed')) {
    if (!to?.fullPath) return window.location.reload();

    window.location.href = to.fullPath;
    return;
  }

  captureException(error);
});

export const pageTitleHandler = useTitle(undefined, { titleTemplate: `%s - ${t('VbZboInmvh8gEfK6qvL50')}` });

const defaultPageDescription = t('-KtH22xNXAOkxT3yH8H77');

router.beforeEach((to, _, next) => {
  const { hazardId, hazardType } = to.params;

  // Addresses a weird issue where there is a double navigation to the same route
  // which causes the hazard type to be set as the hazard ID
  if (hazardId && hazardType && hazardId === hazardType) {
    captureMessage('Route navigation to the same route with the same params', {});
    return;
  }

  const sanitisedHazardType = getSanitisedHazardType(hazardType)
    ? HazardTypeToRouteTitleMap[getSanitisedHazardType(hazardType)!]
    : undefined;

  if (to.name === RouteNames.Hazards) {
    useTitle(to.meta?.title as string);
  } else {
    pageTitleHandler.value = sanitisedHazardType ?? (to?.meta?.title as string) ?? t('a5esAQDYFZozMCewzLiB8');
  }

  const meta = document.createElement('meta');
  meta.name = 'description';
  const description = (to.meta.description as string) ?? defaultPageDescription;
  meta.content = description;
  document.head.appendChild(meta);

  next();
});

export default router;

export * from './types';
